// removed by extract-text-webpack-plugin
module.exports = {"root":"address-book--root--1I15Qx6K organization-home--root--29mpR9MJ"};


//////////////////
// WEBPACK FOOTER
// ./views/addresses/address-book/styles.css
// module id = ./views/addresses/address-book/styles.css
// module chunks = 0